import { HttpClient } from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReleaseNotesService {
  private readonly apiUrl = `${environment.apiUrl}/api/releasenotes`;
  private http =  inject(HttpClient);

  getReleaseNotes(): Observable<string> {
    return this.http.get(this.apiUrl, { responseType: 'text' });
  }
}
